const STORAGE_KEY = 'rc_auth_return_to';

export function isSafeAuthReturnPath(path: string): boolean {
  if (!path.startsWith('/') || path.startsWith('//')) return false;
  if (path.startsWith('/verify-email')) return false;
  return true;
}

/** Remember where to send the user after sign-in or email verification. */
export function saveAuthReturnTo(path?: string): void {
  const candidate = (path ?? `${window.location.pathname}${window.location.search}`).trim();
  if (!isSafeAuthReturnPath(candidate)) return;
  sessionStorage.setItem(STORAGE_KEY, candidate);
}

export function peekAuthReturnTo(searchParams?: URLSearchParams): string {
  const fromUrl = searchParams?.get('returnTo');
  if (fromUrl) {
    try {
      const decoded = decodeURIComponent(fromUrl);
      if (isSafeAuthReturnPath(decoded)) return decoded;
    } catch {
      /* ignore malformed param */
    }
  }
  const stored = sessionStorage.getItem(STORAGE_KEY);
  if (stored && isSafeAuthReturnPath(stored)) return stored;
  return '/';
}

export function consumeAuthReturnTo(searchParams?: URLSearchParams): string {
  const target = peekAuthReturnTo(searchParams);
  sessionStorage.removeItem(STORAGE_KEY);
  return target;
}

export function buildVerifyEmailPath(email: string, returnTo?: string): string {
  const params = new URLSearchParams({ email });
  const destination = returnTo ?? peekAuthReturnTo();
  if (destination !== '/' && isSafeAuthReturnPath(destination)) {
    params.set('returnTo', destination);
  }
  return `/verify-email?${params.toString()}`;
}
